import { Component, OnDestroy, OnInit, ViewChild ,HostListener } from '@angular/core';
import { finalize, firstValueFrom, map, mergeMap, of, Subject, switchMap, tap } from 'rxjs';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule } from "@angular/forms";


import { AppConfig } from "../../../app.config"


import { GlobalCompanyService } from "./global-company.service"
import { NotificationService } from '../../services/service.index';
import { CookieService } from 'ngx-cookie-service';
import { FuseAlertService } from '@fuse/components/alert';

import { MatAutocompleteModule, MatAutocompleteTrigger } from '@angular/material/autocomplete';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatSnackBar, MatSnackBarModule } from '@angular/material/snack-bar';
import { CompanySecuritycodeComponent } from './company-securitycode/company-securitycode.component';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatMenuModule } from '@angular/material/menu';
import { MatToolbarModule } from '@angular/material/toolbar';
import { MatTooltipModule } from '@angular/material/tooltip';
import { Router, RouterModule } from '@angular/router';
import { FuseSharedModule } from '@fuse/shared.module';
import { DashboardNotificationModule } from '../dashboard-notification/dashboard-notification.module';
import { GlobalSelectCompanyModule } from './global-company.module';
import { CommonModule } from '@angular/common';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatCardModule } from '@angular/material/card';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatNativeDateModule, MatRippleModule, MatOptionModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatGridListModule } from '@angular/material/grid-list';
import { MatListModule } from '@angular/material/list';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatRadioModule } from '@angular/material/radio';
import { MatSelectModule } from '@angular/material/select';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatSlideToggleModule } from '@angular/material/slide-toggle';
import { MatSliderModule } from '@angular/material/slider';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { NgxSpinnerService } from 'ngx-spinner';
import { SetFavouriteCompanyComponent } from './setfavouritecompany/setfavouritecompany.component';
import { PolicySelectionEntityDailogBoxComponent } from 'app/main/assessment/policy-selection/policy-selection-entity-dailog-box/policy-selection-entity-dailog-box.component';
import { AppRoute } from 'app/shared/app.routes';
import { PolicyselectionService } from 'app/main/assessment/policy-selection/policyselection.service';
import { CountryStateDropdownService } from '../country-state-dropdown/country-state-dropdown.service';

@Component({
  standalone: true,
  selector: 'global-select-company',
  templateUrl: './global-company.component.html',
  styleUrls: ['./global-company.component.scss'],
  imports:[FormsModule,
  ReactiveFormsModule,
  MatButtonModule,
  MatButtonToggleModule,
  MatCardModule,
  MatCheckboxModule,
  MatChipsModule,
  MatDatepickerModule,
  MatDialogModule,
  MatDividerModule,
  MatExpansionModule,
  MatGridListModule,
  MatIconModule,
  MatInputModule,
  MatListModule,
  MatMenuModule,
  MatNativeDateModule,
  MatPaginatorModule,
  MatProgressBarModule,
  MatProgressSpinnerModule,
  MatRadioModule,
  MatRippleModule,
  MatSelectModule,
  MatSidenavModule,
  MatSliderModule,
  MatSlideToggleModule,
  MatSnackBarModule,
  MatSortModule,
  MatStepperModule,
  MatTableModule,
  MatTabsModule,
  MatToolbarModule,
  MatTooltipModule,
  MatFormFieldModule,
  MatOptionModule,
  CommonModule,
  RouterModule,
  FuseSharedModule,
  MatAutocompleteModule,
  DashboardNotificationModule
  ]
})
export class GlobalSelectCompanyComponent implements OnInit, OnDestroy {
  notificationService: NotificationService;
  autoCompleteFormControl: FormControl;
  rows = new Array<PolicyModel>();
  isCompanyUser: boolean;
  autoCompleteFormEntity: FormControl;
  entityList: any[] = [];
  entityList1: any[] = [];
  entityStr: string;
  entityId: number;
  entityIdd: number;
  selectedEntityId: string = '';
  entityNmae: string = '';
  newEntityName: string = '';
  selectedCompanyName: string;
  entityAutoCompleteList: any[];
  filteredEntityList: any[] = []; 
  region: any;
  regionList: any[];
  regionAutoList: any[];
  companyId: number;
  district: any;
  districtList: any[];
  districtAutoList: any[];

  allCompanyList: any[];
  companyAutocompleteList: any[];

  @ViewChild('companyAutoComplete', { read: MatAutocompleteTrigger })
  companytrigger: MatAutocompleteTrigger;

  @ViewChild('regionAutoComplete', { read: MatAutocompleteTrigger })
  regiontrigger: MatAutocompleteTrigger;

  @ViewChild('districtAutoComplete', { read: MatAutocompleteTrigger })
  districttrigger: MatAutocompleteTrigger;

  @ViewChild('entityAutoComplete', { read: MatAutocompleteTrigger })
  entitytrigger: MatAutocompleteTrigger;

  //@ViewChild('companyAutoComplete', { read: ElementRef }) companyAutoComplete: ElementRef;
  //@ViewChild(MatAutocompleteTrigger) trigger;

  /**Dialog Ref variables**/
  dialogRef: any;

  private inactivityTimer: any;
  private readonly TIMEOUT_DURATION = 15 * 60 * 1000; //set for 15m 
  
  // Add these new methods for handling user activity
  @HostListener('document:mousemove')
  @HostListener('document:keypress')
  @HostListener('document:click')
  @HostListener('document:wheel')
  @HostListener('document:touchmove')
  onUserActivity() {
    this.resetInactivityTimer();
  }

  



  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * 
   * @param globalCompanyService
   * @param appConfig
   * @param matDialog
   * @param snb
   * @param cookieService
   */
  constructor(
    private globalCompanyService: GlobalCompanyService,
    private readonly appConfig: AppConfig,
    private matDialog: MatDialog,
    public fuseAlertService: FuseAlertService,
    private snb: MatSnackBar,
      private _router: Router,
      private _countryStateDropdownService: CountryStateDropdownService,
       private _policySelectionService: PolicyselectionService,
    private _matDialog: MatDialog,
    private cookieService: CookieService,
    private spinner: NgxSpinnerService,
  ) {
    this.notificationService = new NotificationService(snb);
    // Set the defaults
    this.allCompanyList = [];
    this.companyAutocompleteList = [];

    // Set the private defaults
    this._unsubscribeAll = new Subject();
    this.autoCompleteFormEntity = new FormControl();
    this.autoCompleteFormControl = new FormControl();
    this.getGlovalselecteddata();
    this.getAssignedCompany();
  }

  // -----------------------------------------------------------------------------------------------------
  // @ Lifecycle hooks
  // -----------------------------------------------------------------------------------------------------

  /**
   * On init
   */
  ngOnInit(): void {
    this.spinner.show();
    
    this.globalCompanyService.assignedRegion.subscribe(res => {
      this.spinner.hide();
      if (res !== 0 && res.length > 0) {
       // this.fuseAlertService.show("Please Select Company.", res.status);
     
        this.regionList = res;
        this.regionAutoList = res;

      }
    });

    this.globalCompanyService.assignedDistrict.subscribe(res => {
      this.spinner.hide();
      if (res !== 0 && res.length > 0) {
      
        //this.fuseAlertService.show("Please Select Company.", res.status);
        this.districtList = res;
        this.districtAutoList = res;
      }
      
    });

    this.globalCompanyService.companyUser.subscribe(res => {
     // this.fuseAlertService.show("Please Select Company.", res.status);
  
      this.isCompanyUser = res;
    });
    this.resetInactivityTimer();
  }
  async getAssignedCompany(): Promise<void> {
    
    try {
      const res = await firstValueFrom(this.globalCompanyService.getAssignedCompanyToUser());
      if (res.status === 1 && res.data.companyList.length > 0) {
        this.allCompanyList = res.data.companyList;
        this.companyAutocompleteList = res.data.companyList.map(o => {
          return {
            companyId: o.companyId,
            companyName: o.companyName,
            isFavourite: o.isFavourite,
            isSecurityCodeAvailable: o.isSecurityCodeAvailable
          };
        });
        this.setDefaultCompany(res.data.companyList);
       
        if (this.companyId) {
       
          this.bindEntityDropDown(true, true);
        }
      } else {
        console.error('Error from API:', res.message);  
      }
    } catch (error) {
      console.error('Error in API call:', error);  
    }
  }

  private resetInactivityTimer(): void {
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
    this.inactivityTimer = setTimeout(() => {
      this.logoutDueToInactivity();
    }, this.TIMEOUT_DURATION);
  }

  private logoutDueToInactivity(): void {

this._router.navigate(['/sign-out']);
  
  }

  setDefaultCompany(data) {

    const cookieSelectedCompanyExists = this.cookieService.check('RiskSelectedCompany');
  
    if (cookieSelectedCompanyExists) {
      var selectedCompany = JSON.parse(this.cookieService.get('RiskSelectedCompany'));
      
      if (selectedCompany !== null && selectedCompany !== undefined) {
        var currentUserId = this.appConfig.getCurrentUserId();
        
        if (selectedCompany.UserId=== currentUserId) {
          var objCompany = this.allCompanyList.find(x => x.companyId === selectedCompany.SelectedId);
          
          if (objCompany !== undefined && objCompany != null) {
            this.globalCompanyService.globalCompany = objCompany.companyId;
            this.selectedCompanyName = objCompany.companyName;
            this.autoCompleteFormControl.setValue(objCompany.companyName);
         
            this.companyId = objCompany.companyId;
          } else {
            this.setFirstCompanyAsDefault(this.allCompanyList);
          }
        } else {
          this.setFirstCompanyAsDefault(this.allCompanyList);
        }
      }
      else {
        this.setFirstCompanyAsDefault(this.allCompanyList);
      }
    }
    else {
      this.setFirstCompanyAsDefault(this.allCompanyList);
    }
  }

  setFirstCompanyAsDefault(data) {
    if (data.length <= 0) {
      this.globalCompanyService.globalCompany = 0;
      this.companyAutocompleteList = [];
    } else {
      this.globalCompanyService.globalCompany = data[0].companyId;
      this.selectedCompanyName = data[0].companyName;
      this.autoCompleteFormControl.setValue(data[0].companyName);
      
      this.companyId = data[0].companyId;
  
      let newModel = {
        userId: this.appConfig.getCurrentUserId(),
        companyId: data[0].companyId,
        companyName: data[0].companyName,
        isSecurityCodeAvailable: data[0].isSecurityCodeAvailable,
        isCompanyCodeVerify: false
      };

      const selectedIdModelCompany = {
        UserId: this.appConfig.getCurrentUserId(),
        SelectedId: this.companyId,
        Type: "GlobalCompanyId"
      };
      this.AddglobalSelectedId(selectedIdModelCompany)
      // var todayDate = new Date();
      // todayDate.setDate(todayDate.getMonth() + 12);
      // this.cookieService.delete('RiskSelectedCompany', "/");
      // this.cookieService.set('RiskSelectedCompany', JSON.stringify(newModel), todayDate, "/");
    }
  }



  getGlovalselecteddata() {
    ;
    this._countryStateDropdownService.getGlobalSelectedId().subscribe(res => {
        if (res && Array.isArray(res)) {
            ;
         
            const selectedItem = res.find(item =>   
                item.type === "GlobalEntityId" && 
                item.userId === this.appConfig.getCurrentUserId()
            );

            if (selectedItem) {
                const selectedIdModel1 = {
                    UserId: selectedItem.userId,
                    SelectedId: selectedItem.selectedId,
                    Type: "GlobalEntityId"
                };
                
                
          localStorage.setItem("entityId", selectedItem.selectedId);
                const todayDate = new Date();
                todayDate.setDate(todayDate.getDate() + 365);
                this.cookieService.delete("GlobalSelectedEntityFromHeader", "/");
                ;
                this.cookieService.set("GlobalSelectedEntityFromHeader", JSON.stringify(selectedIdModel1), todayDate, "/");               
            } else {
                console.log("No matching GlobalEntityId found for the current user.");
            }
            const selectedItemCompany = res.find(item => 
              item.type === "GlobalCompanyId" && 
              item.userId === this.appConfig.getCurrentUserId()
          );
          if (selectedItemCompany) {
            const selectedIdModel1 = {
                UserId: selectedItemCompany.userId,
                SelectedId: selectedItemCompany.selectedId,
                Type: "GlobalCompanyId"
            };
      localStorage.setItem("entityId", selectedItemCompany.selectedId);
            const todayDate = new Date();
            todayDate.setDate(todayDate.getDate() + 365);

            this.cookieService.delete("RiskSelectedCompany", "/");
            ;
            this.cookieService.set("RiskSelectedCompany", JSON.stringify(selectedIdModel1), todayDate, "/");
            //console.log("Entity0", selectedItemCompany);                
        } else {
            console.log("No matching GlobalEntityId found for the current user.");
        }
        }



        
    });
}

      



  ngAfterViewInit() {
    if (this.selectedCompanyName !== undefined && this.selectedCompanyName !== "") {
      this.autoCompleteFormControl.setValue(this.selectedCompanyName)
    }
    //if (this.trigger !== undefined) {
    //  this.trigger.panelClosingActions
    //    .subscribe(e => {

    //      if (!(e && e.source)) {
    //        this.trigger.closePanel();
    //        this.setDefaultCompany(this.allCompanyList);
    //      }
    //      this.companyAutocompleteList = this.allCompanyList.map(o => {
    //        return {
    //          companyId: o.companyId,
    //          companyName: o.companyName,
    //          isFavourite: o.isFavourite
    //        };
    //      });
    //    });
    //}
  }

  setEntityToCompany() {
    
      var model = {
        companyId: this.companyId,
        entityId: this.entityId
      };
      this._policySelectionService.setEntityToCompany(model).subscribe(result => {
      
      });
    }
    addOrEditEntity(addflag = true) {
      var model = {
        companyId: this.companyId,
        entityId: this.entityId,
        addFlag: addflag,
        pervEntityName: this.entityNmae
      };
      this.dialogRef = this.matDialog.open(PolicySelectionEntityDailogBoxComponent, {
        width: '450px',
        panelClass: "app-policy-selection-entity-dailog-box",
        data: model
      });
  
      this.dialogRef.afterClosed().subscribe(result => {
        if (result) {
          
          localStorage.removeItem('entityChangeCache');
          this.cookieService.delete("GlobalSelectedEntityFromHeader", "/");
          localStorage.removeItem("entityId");
          localStorage.setItem("entityId", result.data);

          const selectedIdModel = {
            UserId: this.appConfig.getCurrentUserId(),
            SelectedId: result.data,
            Type: "GlobalEntityId"
          };
                  
          this.AddglobalSelectedId(selectedIdModel)



          this.getAssignedCompany().then(() => {
            this.globalCompanyService.globalEntity.subscribe(res => {
              if (res === 0) {
                this.fuseAlertService.show(res.message, res.status);
                this._router.navigate([AppRoute.dashboard]);
                return;
              } else {
                if (this.entityIdd != res) {
                  this.entityIdd = res;
                  
                  if (this.companyId) {
                    this.bindEntityDropDown(true, true);
                  }
                }
              }
            });
          });
        } else {
          this.bindEntityDropDown(true, false);
        }
      });
    }


  /**
   * * On chnage Company Auto Complete 
   * @param event
   */
  onChangeCompany(event) {
    localStorage.removeItem("OnchangeSelectedParentId");
    // Prevent multiple calls
    if (this.isCompanyChanging) {
      return;
    }
  
    // Set a flag to prevent concurrent calls
    this.isCompanyChanging = true;
  
    try {
      // Ensure the event is from a selected option
      if (!event.source.selected) {
        this.isCompanyChanging = false;
        return;
      }
  
      // Set company ID
      this.companyId = event.source.value.companyId;
  
      // Use RxJS operators to handle the flow
      this.bindEntityDropDownOncompany(this.companyId).pipe(
        finalize(() => {
          // Ensure the flag is reset in all scenarios
          this.isCompanyChanging = false;
        })
      ).subscribe({
        next: () => {
          // Proceed with company change process
          let newModel = {
            userId: this.appConfig.getCurrentUserId(),
            companyId: event.source.value.companyId,
            companyName: event.source.value.companyName,
            isSecurityCodeAvailable: event.source.value.isSecurityCodeAvailable,
            isCompanyCodeVerify: false
          };
  
          if (newModel.isSecurityCodeAvailable) {
            let currentUser = this.appConfig.getCurrentUser();
  
            /* Check user has more than one company */
            if (currentUser.isCompanyMoreThenOne) {
              /* Check if User is SystemPowerAdmin or SystemAdmin */
              if (currentUser.isSpaOrSa) {
                /* Check if Security Code is Enabled */
                if (currentUser.isSecurityCodeEnabled) {
                  this.showCompanySecurityCodeModal(newModel);
                } else {
                  newModel.isCompanyCodeVerify = true;
                  this.afterCompanyChangeProcess(newModel, false, false);
                }
              } else {
                this.showCompanySecurityCodeModal(newModel);
              }
            } else {
              newModel.isCompanyCodeVerify = true;
              this.afterCompanyChangeProcess(newModel, false, false);
            }
          } else {
            newModel.isCompanyCodeVerify = true;
            this.afterCompanyChangeProcess(newModel, false, newModel.isCompanyCodeVerify);
          }
        },
        error: (error) => {
          console.error('Error in company change process:', error);
          // Optionally handle the error
        }
      });
    } catch (error) {
      console.error('Unexpected error in onChangeCompany:', error);
      this.isCompanyChanging = false;
    }
  }
  
  // In the component class, add this property
  isCompanyChanging = false;

  bindEntityDropDownOncompany(companyId) {
    
    return this._policySelectionService.getEntitiesByCompany(companyId).pipe(
      mergeMap(resultEntities => {
        this.resetEntity();
        this.entityList1 = resultEntities.data;
  
        const selectedIdModelAfterCompany = {
          UserId: this.appConfig.getCurrentUserId(),
          SelectedId: this.entityList1[0].value,
          Type: "GlobalEntityId"
        };
        
        
        localStorage.removeItem("entityId");
        localStorage.setItem("entityId",this.entityList1[0].value,);
        return this._countryStateDropdownService.AddGlobalSelectedId(selectedIdModelAfterCompany).pipe(
          tap(res => {
            if (res.status === 1) {
              const todayDate = new Date();
              todayDate.setDate(todayDate.getDate() + 365);
              
              this.cookieService.delete("GlobalSelectedEntityFromHeader", "/");
              this.cookieService.set("GlobalSelectedEntityFromHeader", JSON.stringify(selectedIdModelAfterCompany), todayDate, "/");
            }
            
            
            const selectedIdModelCompany = {
              UserId: this.appConfig.getCurrentUserId(),
              SelectedId: companyId,
              Type: "GlobalCompanyId"
            };
            this.AddglobalSelectedId(selectedIdModelCompany)
          }),
          
          map(() => resultEntities)
        );
      })
    );
  }
  
  
  
  onChangeEntity(event, item) {
    localStorage.setItem("OnentityChnage","true")
    localStorage.removeItem("OnchangeSelectedParentId");
    localStorage.removeItem("ComparisonType");
    localStorage.removeItem("selectedParentAssessment1");
 localStorage.removeItem("selectedParentAssessment2");
 localStorage.removeItem("selecteCategory");
    
    if (event.source.selected) {
      this.entityId = item.value;
      this.entityNmae = item.text;
      this.selectedEntityId = item.value;
    }
    
    const selectedIdModel = {
      UserId: this.appConfig.getCurrentUserId(),
      SelectedId: this.entityId,
      Type: "GlobalEntityId"
    };
    
    const addGlobalSelectedIdPromise = () => {
      return new Promise((resolve, reject) => {
        this._countryStateDropdownService.AddGlobalSelectedId(selectedIdModel).subscribe({
          next: (res) => {
            if (res.status === 1) {
              const todayDate = new Date();
              todayDate.setDate(todayDate.getDate() + 365);
              
              this.cookieService.delete("GlobalSelectedEntityFromHeader", "/");
              this.cookieService.set("GlobalSelectedEntityFromHeader", JSON.stringify(selectedIdModel), todayDate, "/");
            }
            resolve(res);
          },
          error: (error) => {
            reject(error);
          }
        });
      });
    };
    
    const entityModel = {
      userId: this.appConfig.getCurrentUserId(),
      companyId: this.companyId,
      entityId: this.entityId,
      entityName: this.entityNmae,
      selectedEntityId: this.selectedEntityId
    };
    
    localStorage.removeItem("entityName");
    localStorage.removeItem("entityId");
    localStorage.setItem("entityName", this.entityNmae);
    localStorage.setItem("entityId", this.selectedEntityId);
    
    const processEntityChange = async () => {
      try {
        await addGlobalSelectedIdPromise();
        this.afterEntityChangeProcess(entityModel, false, false);
      } catch (error) {
        console.error('Error in adding global selected ID:', error);

      }
    };
    
    processEntityChange();
}

AddglobalSelectedId(selectedIdModel){
  
  this._countryStateDropdownService.AddGlobalSelectedId(selectedIdModel).subscribe(res => {
    if (res.status === 1) {
      const todayDate = new Date();
      todayDate.setDate(todayDate.getDate() + 365);
          
      this.cookieService.delete("GlobalSelectedEntityFromHeader", "/");
      this.cookieService.set("GlobalSelectedEntityFromHeader", JSON.stringify(selectedIdModel), todayDate, "/");
    }
  });
}

  // getGlovalselecteddata(){
  //   
  //   this._countryStateDropdownService.getGlobalSelectedId().subscribe(res => {
  //     if (res.status === 1) {

  //   }})
      
  // }
  afterEntityChangeProcess(model, isNeedVerify: boolean, isCompanyCodeVerify: boolean) {
    
    if (isNeedVerify) {
      if (!isCompanyCodeVerify) {
        this.globalCompanyService.globalCompany.subscribe(res => {
          if (res === 0) {
            return;
          } else {
            const selectedCompany = this.globalCompanyService.assignedCompanyList.value.find(x => x.companyId === res);
            this.autoCompleteFormControl.setValue(selectedCompany.companyName);
  
            model = {
              userId: this.appConfig.getCurrentUserId(),
              companyId: this.companyId,
              entityId:  this.entityId,
              entityName:  this.entityNmae,
              selectedEntityId:this.selectedEntityId
            };
          }
        });
      } else {
        this.globalCompanyService.globalParentAssessment = 0;
        this.globalCompanyService.globalCompany = model.companyId;
      }
    } else {
      this.globalCompanyService.globalParentAssessment = 0;
      this.globalCompanyService.globalCompany = model.companyId;
    }
  
    
    this.companyId = model.companyId;
    
    // const todayDate = new Date();
    // todayDate.setDate(todayDate.getDate() + 365);
  
    // const userId = this.appConfig.getCurrentUserId(); // Get current userId
    // const cookieName = `RiskSelectedEntity_${userId}`; // Unique cookie for each user
  
    // this.cookieService.delete(cookieName, "/");
    // this.cookieService.set(cookieName, JSON.stringify(model), todayDate, "/");
  
    localStorage.setItem('entityChangeCache', 'true'); 

    this.bindEntityDropDown(true,false);
  }


  afterCompanyChangeProcess(model, isNeedVerify: boolean, isCompanyCodeVerify: boolean) {
    
    if (isNeedVerify) {
      if (!isCompanyCodeVerify) {
        this.globalCompanyService.globalCompany.subscribe(res => {
          if (res === 0) {
            return;
          } else {
            const selectedCompany = this.globalCompanyService.assignedCompanyList.value.find(x => x.companyId === res);
            this.autoCompleteFormControl.setValue(selectedCompany.companyName);
  
            model = {
              userId: this.appConfig.getCurrentUserId(),
              companyId: selectedCompany.companyId,
              companyName: selectedCompany.companyName,
              isSecurityCodeAvailable: selectedCompany.isSecurityCodeAvailable,
              isCompanyCodeVerify: true
            };
          }
        });
      } else {
        this.globalCompanyService.globalParentAssessment = 0;
        this.globalCompanyService.globalCompany = model.companyId;
      }
    } else {
      this.globalCompanyService.globalParentAssessment = 0;
      this.globalCompanyService.globalCompany = model.companyId;
    }
  
    this.companyId = model.companyId;
    
    var todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + 365);
    this.cookieService.delete('RiskSelectedCompany', "/");
    this.cookieService.set('RiskSelectedCompany', JSON.stringify(model), todayDate, "/");
 
    this.bindEntityDropDown(true,false,true);
  }

  
  displayFnAutoEntityComplete(entity) {
    if (entity != null) {
      return entity;
    }
    return entity;
  }
  
  bindEntityDropDown(flag = false, isAfterChangeEntity = true,isAfterCompanyEntity=true) {
    
    this.globalCompanyService.getEntitiesByCompany(this.companyId).subscribe(resultEntities => {
      this.resetEntity();
      this.entityAutoCompleteList = [];
      this.entityList = [];
      
      this.entityAutoCompleteList = resultEntities.data;
      this.filteredEntityList = resultEntities.data;
      this.entityList = resultEntities.data;
      
      if (isAfterChangeEntity && this.entityList && this.entityList.length > 0) {
        const entity = this.entityList[0];
        
        const entityChangeCache = localStorage.getItem('entityChangeCache');
        
        if (entity !== undefined && entity !== null && entityChangeCache === null) {
          this.saveEntityToCookie(entity.value, entity.text);
        }
      }
      
      this.entityList.unshift({ value: 0, text: "All" });

      const cookieSelectedEntityExists = this.cookieService.check("GlobalSelectedEntityFromHeader");
      
      if (cookieSelectedEntityExists) {
        const selectedEntity = JSON.parse(this.cookieService.get("GlobalSelectedEntityFromHeader"));
        localStorage.removeItem("entityId");
        localStorage.setItem("entityId",selectedEntity.SelectedId);
        
        
        if (selectedEntity !== null && selectedEntity !== undefined) {
          
          const currentUserId = this.appConfig.getCurrentUserId();
          
          if (selectedEntity.UserId=== currentUserId && selectedEntity.Type=== "GlobalEntityId") {
     
            const entityObj = this.entityList.find(x => x.value === selectedEntity.SelectedId);
            
            if (entityObj !== undefined && entityObj !== null) {
              this.entityId = entityObj.value;
              this.entityNmae = entityObj.text;
              this.selectedEntityId = entityObj.value;
              this.autoCompleteFormEntity.setValue(entityObj.text);
              
              localStorage.removeItem("entityName");
              localStorage.removeItem("entityId");
              localStorage.setItem("entityName", this.entityNmae);
              localStorage.setItem("entityId", this.selectedEntityId);
              
              return; 
            }
          }
        }
      }
      
      if (this.entityList && this.entityList.length > 0) {
        const firstEntity = this.entityList[1];
        this.entityId = firstEntity.value;
        this.entityNmae = firstEntity.text;
        this.selectedEntityId = firstEntity.value;
   
        this.autoCompleteFormEntity.setValue(firstEntity.text);
        localStorage.removeItem("entityName");
        localStorage.removeItem("entityId");
        localStorage.setItem("entityName", this.entityNmae);
        localStorage.setItem("entityId", this.selectedEntityId);
        
        this.saveEntityToCookie(this.entityId, this.entityNmae);
      }
      
      if (flag)
        this.showTextEntity();
    });
  }
     

   saveEntityToCookie(entityId, entityName) {
    
    const entityModel = {
      userId: this.appConfig.getCurrentUserId(),
      companyId: this.companyId,
      entityId: entityId,
      entityName: entityName
    };
    
    const todayDate = new Date();
    todayDate.setDate(todayDate.getDate() + 365);
    this.cookieService.delete('RiskSelectedEntity', "/");
    this.cookieService.set('RiskSelectedEntity', JSON.stringify(entityModel), todayDate, "/");
  }
     
  showTextEntity() {    
    if (this.entityStr == "" || this.entityStr == undefined) {
      if (this.entityId != 0) {
        var entityObjIndex = this.entityList.findIndex(x => x.value == this.entityId);
        if (entityObjIndex >= 0) {
          this.entityNmae = this.entityList[entityObjIndex].text;
          this.selectedEntityId = this.entityList[entityObjIndex].value;
          this.autoCompleteFormEntity.setValue(this.entityNmae);       
          this.saveEntityToCookie(this.entityId, this.entityNmae);
        }
      }
    }
  }

  resetEntity() {
    this.entityList = [];
    this.entityAutoCompleteList = [];
    this.filteredEntityList = [];
  }


  onInputEntityChanged(searchStr: string): void {
    if (!this.entityAutoCompleteList) {
      return;
    }
    
    if (searchStr === '') {
      this.filteredEntityList = this.entityAutoCompleteList;
    } else {
      this.filteredEntityList = this.entityAutoCompleteList.filter(option => 
        option.text.toLowerCase().includes(searchStr.toLowerCase())
      );
    }
  }

  showCompanySecurityCodeModal(model) {
    this.dialogRef = this.matDialog.open(CompanySecuritycodeComponent, {
      width: '450px',
      panelClass: "company-security-code",
      data: model
    });

    this.dialogRef.afterClosed().subscribe(response => {
      if (!response) {
      }
      const actionType: string = response[0];
      const isCompanyCodeVerify: boolean = response[1];
      model.isCompanyCodeVerify = isCompanyCodeVerify;
      switch (actionType) {
        case 'submit': {
          this.afterCompanyChangeProcess(model, true, isCompanyCodeVerify);
          let message = `Company code is${isCompanyCodeVerify ? '' : ' not'} verified.`;
          this.fuseAlertService.show(message, 2);
          //this.notificationService.showNotification(message);
          break;
        }
        case 'exit':
          this.afterCompanyChangeProcess(model, true, false);
          break;
        default:
          this.afterCompanyChangeProcess(model, true, false);
          this.fuseAlertService.show("Company code is not verified.", 2);
          //this.notificationService.showNotification("Company code is not verified.");
          break;
      }
    });
  }

  /**Set Selected First companay by default**/
 

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    // Unsubscribe from all subscriptions
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    if (this.inactivityTimer) {
      clearTimeout(this.inactivityTimer);
    }
  }


  /**Auto complete Display Function**/
  displayFnAutoComplete(company) {
    if (company != null && company.companyName != null) {
      return company.companyName;
    } else return company;
  }

  /**Auto complete filter on change**/
  onInputChanged(searchStr: string): void {
    this.companyAutocompleteList = [];

    this.companyAutocompleteList = this.allCompanyList.filter(option =>
      option.companyName.toLowerCase().includes(searchStr.toLowerCase())).map(o => {
        return {
          companyId: o.companyId,
          companyName: o.companyName,
          isFavourite: o.isFavourite,
          isSecurityCodeAvailable: o.isSecurityCodeAvailable
        };
      });

  }

  /**Auto complete Display Function**/
  displayFnAutoRegionComplete(region) {
    if (region != null && region.region != null) {
      return region.region;
    } else return region;
  }

  /**Auto complete filter on change**/
  onInputRegionChanged(searchStr: string): void {
    this.regionAutoList = [];
    if (searchStr == "") {
      this.district = "";
      this.autoCompleteFormControl.setValue("");
      this.companyAutocompleteList = this.allCompanyList.map(o => {
        return {
          companyId: o.companyId,
          companyName: o.companyName,
          isFavourite: o.isFavourite,
          isSecurityCodeAvailable: o.isSecurityCodeAvailable
        };
      });

      this.districtAutoList = this.districtList;

      this.regionAutoList = this.regionList;

      this.setFirstCompanyAsDefault(this.companyAutocompleteList);
    }
    else {
      this.regionAutoList = this.regionAutoList.filter(option =>
        option.region.toLowerCase().includes(searchStr.toLowerCase()));
    }

  }

  onChangeRegion(event) {
    if (event.source.selected) {
      var region = event.source.value.region;

      this.district = "";
      this.autoCompleteFormControl.setValue("");
      var district = this.allCompanyList.filter(x => x.region == region).map(o => {
        return {
          district: o.district
        };
      });
      this.districtAutoList = district;

      this.companyAutocompleteList = this.allCompanyList.filter(x => x.region == region).map(o => {
        return {
          companyId: o.companyId,
          companyName: o.companyName,
          isFavourite: o.isFavourite,
          isSecurityCodeAvailable: o.isSecurityCodeAvailable
        };
      });
      this.setFirstCompanyAsDefault(this.companyAutocompleteList);
    }

  }

  /**Auto complete Display Function**/
  displayFnAutoDistrictComplete(district) {
    if (district != null && district.district != null) {
      return district.district;
    } else return district;
  }


  /**Auto complete filter on change**/
  onInputDistrictChanged(searchStr: string): void {
    this.districtAutoList = [];

    //if (searchStr == "") {
    //  this.district = "";
    //  this.autoCompleteFormControl.setValue("");
    //  this.companyAutocompleteList = this.allCompanyList.filter(x => x.region == this.region).map(o => {
    //    return {
    //      companyId: o.companyId,
    //      companyName: o.companyName,
    //      isFavourite: o.isFavourite
    //    };
    //  });
    //  this.districtAutoList = this.allCompanyList.filter(x =>x.region == this.region).map(o => {
    //    return {
    //     district:o.district
    //    };
    //  });

    //  this.setFirstCompanyAsDefault(this.companyAutocompleteList);
    //}
    //else {
    this.districtAutoList = this.districtAutoList.filter(option =>
      option.district.toLowerCase().includes(searchStr.toLowerCase()));
    //}

  }

  onChangeDistrict(event) {
    if (event.source.selected) {

      var district = event.source.value.district;
      this.autoCompleteFormControl.setValue("");
      this.companyAutocompleteList = this.allCompanyList.filter(x => x.district == district).map(o => {
        return {
          companyId: o.companyId,
          companyName: o.companyName,
          isFavourite: o.isFavourite
        };
      });
      this.setFirstCompanyAsDefault(this.companyAutocompleteList);
    }

  }

  setFavouriteCompany() {
        this.dialogRef = this._matDialog.open(SetFavouriteCompanyComponent, {        
        });    
        this.dialogRef.afterClosed()
          .subscribe((response: FormGroup<any>[]) => {
            if (!response) {
            }
            const actionType: any = response[0];
            const formData: FormGroup = response[1];
            switch (actionType) {
              case "submit":
                var model = {
                  favouriteCompany: formData.controls.favouriteCompany.value
                }
                this.globalCompanyService.setFavouriteCompany(model).subscribe(res => {
                  if (res.status === 1) {
                    this.fuseAlertService.show("Favourite set successfully.", res.status);                   
                    this.globalCompanyService.setAssignedCompanyList();
                  }
                });
                break;
              /**
               * Delete
               */
              case "cancel":
                break;
            }
          });
    
      }

}
export class PolicyModel {
  policyCode: number;
  policyName: string;
  policyComment: string;
  policyDescription: string;
  relatedPolicy: string;
  isActive: boolean;
}
